import React, { useState, useEffect } from 'react';
import '../../../Styles/Styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import CssClass from "../../../Styles/common.module.css";
import BackModal from '../../BasicElements/BackModal.js';
import ConfirmModal from '../../BasicElements/ConfirmModal.js';
import http from "../../../Common/http-common.js";
import * as common from "../../../Common/common.js";
import * as Comp from "../../../Common/CommonComponents.js";
import { differenceInYears, differenceInMonths, differenceInDays, format } from 'date-fns';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const InsertEmployee = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading....");
  const [showUpdateEntitlement, setShowUpdateEntitlement] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [inputError, setInputError] = useState({});
  const [addData, setAddData] = useState([]);
  const [deptList, setDeptList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [workTypeList, setWorkTypeList] = useState([]);
  const [selectedDept, setSelectedDept] = useState([]);
  const [selectedRole, setSelectedRole] = useState([]);
  const [selectedWorkType, setSelectedWorkType] = useState([]);
  const [leaveEntitlementList, setLeaveEntitlementList] = useState([]);
  const [editEntitlementData, setEditEntitlementData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [isChecked, setIsChecked] = useState(false);

  const generateDefaultPassword = () => {
    const length = 12; // Length of the password
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    let password = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }
    return password;
  };
  
  const encryptPassword = (password) => {
    return common.c_EncryptData(password.trim()).toString();
  };

  //#region useEffect to get dept list 
  useEffect(() => {
    let functionName = "";
    try {
      functionName = "Get Dept List";
      http
        .get("api/profile/GetDeptList?_sysUser=" + userId, { timeout: 100000 })
        .then((response) => {
        const listItems = response.data.map(dept => ({
          key: dept.DEPT_ID,
          value: dept.DEPT_ID,
          label: `${dept.DEPT_NAME}`
        }));
        setDeptList(listItems);
      })
      .catch((err) => {
        toast.error("Error on getting dept list. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      })
    } catch (err) {
      toast.error("Error on getting dept list. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }, []);
  //#endregion

  //#region useEffect to get role list 
  useEffect(() => {
    let functionName = "";
    try {
      functionName = "Get Role List";
      http
        .get("api/profile/GetRoleList?_sysUser=" + userId, { timeout: 100000 })
        .then((response) => {
        const listItems = response.data.map(role => ({
          key: role.ROLE_ID,
          value: role.ROLE_ID,
          label: `${role.ROLE_NAME}`
        }));
        setRoleList(listItems);
      })
      .catch((err) => {
        toast.error("Error on getting user role list. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      })
    } catch (err) {
      toast.error("Error on getting user role list. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }, []);
  //#endregion

  //#region useEffect to get work type list 
  useEffect(() => {
    let functionName = "";
    try {
      functionName = "Get Work Type List";
      http
        .get("api/profile/GetWorkTypeList?_sysUser=" + userId, { timeout: 100000 })
        .then((response) => {
        const listItems = response.data.map(workType => ({
          key: workType.CATEGORY_TYPE_MST_ID,
          value: workType.CATEGORY_TYPE_MST_ID,
          label: `${workType.CATEGORY_TYPE_NAME}`
        }));
        setWorkTypeList(listItems);
      })
      .catch((err) => {
        toast.error("Error on getting work type list. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      })
    } catch (err) {
      toast.error("Error on getting work type list. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }, []);
  //#endregion

  //#region useEffect to get leave entitlement 
  useEffect(() => {
    let functionName = "";
    try {
      functionName = "Get Leave Entitlement";
      const workType = selectedWorkType?.key || "";
      const startDateStr = addData.SERVICE_STARTDATE || "";
      const endDateStr = addData.SERVICE_ENDDATE || "";
      let totalYears = '';
      const listItems = [];

      if (startDateStr) {
        const startDate = new Date(startDateStr);
        let endDate = new Date();

        if (endDateStr && new Date(endDateStr) > startDate) {
          endDate = new Date(endDateStr);
        }

        totalYears = differenceInYears(endDate, startDate);
      }

      http
        .get("api/profile/GetLeaveEntitlement?_sysUser=" + userId
            + "&_workType=" + workType
            + "&_totalYears=" + totalYears
            + "&_serviceDate=" + startDateStr, 
            { timeout: 100000 })
        .then((response) => {
        if (response.data.length > 0) {
          response.data.forEach((data) => {
            listItems.push({
              key: data.CATEGORY_TYPE_MST_ID,
              CATEGORY_TYPE_MST_ID: data.CATEGORY_TYPE_MST_ID,
              CATEGORY_DESC: data.CATEGORY_DESC,
              CATEGORY_TYPE_NAME: data.CATEGORY_TYPE_NAME,
              ENTITLEMENT: data.ENTITLEMENT ?? '0',
            });
          });
        }
        setLeaveEntitlementList(listItems);
      })
      .catch((err) => {
        toast.error("Error on getting leave entitlement. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      })
    } catch (err) {
      toast.error("Error on getting leave entitlement. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }, [selectedWorkType, addData.SERVICE_STARTDATE, addData.SERVICE_ENDDATE]);
  //#endregion

  function RegisterNewUser() {
    let functionName = "";
    try {
      functionName = props.page + RegisterNewUser.name;
      setLoading(true);
      setLoadingText("Registering New User, PLease wait....")
      const defaultPassword = generateDefaultPassword();
      const encryptedPassword = encryptPassword(defaultPassword);
      const selectedDepts = selectedDept?.key || "";
      const selectedRoles = selectedRole.map(r => r.key);
      const selectedWorkTypes = selectedWorkType?.key || "";

      const data = {
        USER_MST_GUID: addData.USER_ID,
        USERNAME: addData.USERNAME.trim(),
        EMAIL: addData.EMAIL !== undefined ? addData.EMAIL.trim() : "",
        DEFAULT_PASSWORD: encryptedPassword.toString(),
        DEPT_ID: selectedDepts,
        USER_ROLE_LIST: selectedRoles,
        EMPLOYMENT_STATUS: selectedWorkTypes,
        SERVICE_STARTDATE: addData.SERVICE_STARTDATE,
        SERVICE_ENDDATE: selectedWorkType?.label === "Resigned" ? addData.SERVICE_ENDDATE : null,
        EMAIL_FLAG: isChecked ? "Y" : "N", 
        ENTITLEMENT_LIST: leaveEntitlementList,
        UPDATE_ID: userId,
        FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
      };
      
      http
        .post("api/profile/RegisterUser", data, { timeout: 10000 })
        .then((response) => {
          if (response.data.DUPLICATE_USERNAME === true) {
            toast.error("User Name " + response.data.USERNAME + " already exist.");
          } 
          else if (response.data.DUPLICATE_EMAIL === true) {
            toast.error("Email " + response.data.EMAIL + " already exist.");
          }
          else {
            toast.success("User is successfully inserted.");
            props.onReload();
          }
        })
        .catch((err) => {
          toast.error("Failed to insert user. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
    } catch (err) {
      toast.error("Failed to insert user. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  };
  //#endregion

  function calculateServicePeriod(startDateStr, endDateStr) {
    if (!startDateStr) return "";

    const startDate = new Date(startDateStr);
    let endDate = endDateStr && endDateStr.trim?.() !== "" ? new Date(endDateStr) : new Date();

    const years = differenceInYears(endDate, startDate);
    const afterYears = new Date(startDate);
    afterYears.setFullYear(afterYears.getFullYear() + years);

    const months = differenceInMonths(endDate, afterYears);
    const afterMonths = new Date(afterYears);
    afterMonths.setMonth(afterMonths.getMonth() + months);

    const days = differenceInDays(endDate, afterMonths);

    const yearText = `${years} year${years !== 1 ? "s" : ""}`;
    const monthText = `${months} month${months !== 1 ? "s" : ""}`;
    const dayText = `${days} day${days !== 1 ? "s" : ""}`;

    return `${yearText}, ${monthText}, ${dayText}`;
  }

  useEffect(() => {
    const period = calculateServicePeriod(addData.SERVICE_STARTDATE, addData.SERVICE_ENDDATE);
    setAddData((prev) => ({
      ...prev,
      SERVICE_PERIOD: period,
    }));
  }, [addData.SERVICE_STARTDATE, addData.SERVICE_ENDDATE]);

  const inputRequiredHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;

		if (id === "SERVICE_ENDDATE") {
      if (selectedWorkType?.label === "Resigned") {
        if (val.length === 0 || val.trim().length === 0) {
          setInputError((prevState) => ({
            ...prevState,
            [id]: `${name} could not be empty.`,
          }));
        } else {
          setInputError((prevState) => ({
            ...prevState,
            [id]: "",
          }));
        }
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
		} else {
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: `${name} could not be empty.`,
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
    }
		setAddData((prevState) => ({
			...prevState,
			[id]: val,
		}));

		setHasChanges(true);
  }

  const inputEntitlementRequiredHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;
    
    const categoryType = editEntitlementData?.CATEGORY_TYPE_MST_ID;
    const decimalPattern = categoryType === "46E44004-B5D3-4702-A188-3C09A6F663A9" 
      ? /^(0|[1-9]\d*)(\.\d{0,2})?$/
      : categoryType === "D80DF667-D6BF-43AA-93A1-441C99663C04"
        ? /^(0|[1-9]\d*)$/
        : /^(0|[1-9]\d*)(\.\d{0,1})?$/;

    const isValid = val === "" || decimalPattern.test(val);

		if (val.length === 0 || val.trim().length === 0) {
			setInputError((prevState) => ({
				...prevState,
				[id]: `${name} could not be empty.`,
			}));
		} else if (!isValid) {
      return;
    } else {
			setInputError((prevState) => ({
				...prevState,
				[id]: "",
			}));
		}
		setEditEntitlementData((prevState) => ({
			...prevState,
			[id]: val,
		}));
  }

  const inputUnrequiredHandler = (event) => {
    let functionName = "";
    
    try {
      functionName = inputUnrequiredHandler.name;
      const id = event.target.id;
      const val = event.target.value;
    
      furtherValidateInput(id, val);
      setAddData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
    setHasChanges(true);
  }

  function furtherValidateInput(id, val) {
    if (id === "EMAIL") {
      if (!common.EMAIL_REGEX.test(val) && val !== "") {
        setInputError((prevState) => ({
          ...prevState,
          [id]: ("Please enter a proper email."),
        }));
        return false;
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: (""),
        }));
        return true;
      }
    }
    else {
      return true;
    }
  }
  
  const selectDeptHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectDeptHandler.name;
      if (val && Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          DEPT: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          DEPT: "Department could not be empty.",
        }));
      }
      setSelectedDept(val);
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
    setHasChanges(true);
  }
  
  const selectRoleHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectRoleHandler.name;
      if (val && val.length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          ROLE: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          ROLE: "Role could not be empty.",
        }));
      }
      setSelectedRole(val);
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
    setHasChanges(true);
  }
  
  const selectWorkTypeHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectWorkTypeHandler.name;
      if (val && Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          WORK_TYPE: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          WORK_TYPE: "Work type could not be empty.",
        }));
      }
      setInputError((prevState) => ({
        ...prevState,
        SERVICE_ENDDATE: "",
      }));
      setSelectedWorkType(val);
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
    setHasChanges(true);
  }

  const emailHolidayHandler = (e) => {
		setIsChecked(e.target.checked);
		setHasChanges(true);
	};
  
  const hideModal = () => {
    setAddData([]);
    setInputError([]);
    setSelectedDept([]);
    setSelectedRole([]);
    setSelectedWorkType([]);
    setEditEntitlementData([]);
		setHasChanges(false);
    setIsChecked(false);
    props.onHide();
  };

  const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

  const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

  const handleConfirm = () => {
		var flag = true;
		if (addData.USERNAME === undefined) {
			flag = false;
			setInputError((prevState) => ({
				...prevState,
				USERNAME: ("User Name could not be empty."),
			}));
		}

		if (addData.EMAIL === undefined) {
			flag = false;
			setInputError((prevState) => ({
				...prevState,
				EMAIL: ("Email could not be empty."),
			}));
		}

		if (Object.keys(selectedDept).length === 0) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        DEPT: ("Department could not be empty."),
      }));
    } else {
      setInputError((prevState) => ({
        ...prevState,
        DEPT: (""),
      }));
    }

		if (Object.keys(selectedRole).length === 0) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        ROLE: ("Role could not be empty."),
      }));
    } else {
      setInputError((prevState) => ({
        ...prevState,
        ROLE: (""),
      }));
    }

		if (Object.keys(selectedWorkType).length === 0) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        WORK_TYPE: ("Work Type could not be empty."),
      }));
    } else {
      setInputError((prevState) => ({
        ...prevState,
        WORK_TYPE: (""),
      }));
    }

		if (addData.SERVICE_STARTDATE === undefined) {
			flag = false;
			setInputError((prevState) => ({
				...prevState,
				SERVICE_STARTDATE: ("Service Start Date could not be empty."),
			}));
		}

    if (selectedWorkType?.label === "Resigned" && addData.SERVICE_ENDDATE === undefined) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				SERVICE_ENDDATE: ("Service End Date could not be empty."),
			}));
    }

		if (Object.values(inputError).filter(v => v !== "").length === 0 && flag) {
			setShowConfirmModal(true);
		}
  };

  const handleConfirmModal = () => {
    RegisterNewUser();
    setShowConfirmModal(false); // Hide confirm modal
		hideModal();
  };

	const handleConfirmModalClose = () => {
    setShowConfirmModal(false); // Hide confirm modal
  };

  const showUpdateEntitlementModal = (e, rowData) => {
    setShowUpdateEntitlement(!showUpdateEntitlement);
    setEditEntitlementData(rowData);
  };

  const hideUpdateEntitlementModal = () => {
    setShowUpdateEntitlement(!showUpdateEntitlement);
    setEditEntitlementData(null);
    setInputError([]);
  };
  
  const handleEntitlementBack = () => {
		hideUpdateEntitlementModal();
	};

  const handleEntitlementConfirm = () => {
    const updatedList = leaveEntitlementList.map((item) =>
      item.CATEGORY_TYPE_MST_ID === editEntitlementData.CATEGORY_TYPE_MST_ID &&
      item.CATEGORY_DESC === editEntitlementData.CATEGORY_DESC
        ? { ...item, ENTITLEMENT: editEntitlementData.ENTITLEMENT }
        : item
    );

    setLeaveEntitlementList(updatedList);
    setShowUpdateEntitlement(!showUpdateEntitlement);
    setEditEntitlementData(null);
		setHasChanges(true);
  };

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered size="lg">
        <Modal.Header>
          <div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
            <Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Create</Modal.Title>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div style={{ marginBottom: "15px" }}>
            <h5>Personal Details</h5>
            <hr />
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="USERNAME"
                  label="Name*"
                  name="User Name"
                  type="text"
                  className="form-control"
                  errorMessage={inputError.USERNAME}
                  value={addData.USERNAME}
                  onChange={inputRequiredHandler}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="EMAIL"
                  label="Email*"
                  name="Email"
                  type="text"
                  className="form-control"
                  errorMessage={inputError.EMAIL}
                  value={addData.EMAIL}
                  onChange={inputUnrequiredHandler}
                />
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Comp.Select
                  id="DEPT"
                  label="Department*"
                  type="text"
                  options={deptList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  errorMessage={inputError.DEPT}
                  value={selectedDept}
                  onChange={selectDeptHandler}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Comp.Select
                  id="ROLE"
                  label="Role*"
                  type="text"
                  options={roleList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  errorMessage={inputError.ROLE}
                  value={selectedRole}
                  onChange={selectRoleHandler}
                  isMulti
                  isClearable
                />
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Comp.Select
                  id="WORK_TYPE"
                  label="Work Type*"
                  type="text"
                  options={workTypeList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  errorMessage={inputError.WORK_TYPE}
                  value={selectedWorkType}
                  onChange={selectWorkTypeHandler}
                />
              </div>
              <div style={{ flex: 1 }}>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="SERVICE_STARTDATE"
                  label="Service Start Date*"
                  name="Service Start Date"
                  type="date"
                  className="form-control"
                  errorMessage={inputError.SERVICE_STARTDATE}
                  value={addData.SERVICE_STARTDATE ? addData.SERVICE_STARTDATE.slice(0, 10) : ""}
                  onChange={inputRequiredHandler}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="SERVICE_ENDDATE"
                  label={`Service End Date${selectedWorkType?.label === "Resigned" ? "*" : ""}`}
                  name="Service End Date"
                  type="date"
                  className="form-control"
                  errorMessage={inputError.SERVICE_ENDDATE}
                  value={selectedWorkType?.label === "Resigned" ? addData.SERVICE_ENDDATE ? addData.SERVICE_ENDDATE.slice(0, 10) : "" : ""}
                  onChange={inputRequiredHandler}
                  disabled={selectedWorkType?.label !== "Resigned"}
                />
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="SERVICE_PERIOD"
                  label="Service Period"
                  name="Service Period"
                  type="text"
                  className="form-control"
                  value={addData.SERVICE_PERIOD}
                  readOnly
                />
              </div>
              <div style={{ flex: 1 }}>
              </div>
            </div>
          </div>
          <div>
            <h5>Entitlements</h5>
            <hr />
            <div style={{ width: "100%", marginBottom: "15px" }}>
              <DataTable value={leaveEntitlementList} dataKey="USER_ENTITLEMENT_ID" className="datatable">
                <Column header="Action"
                  style={{ width: '30px' }}
                  body={(rowData) => (
                    <div style={{ textAlign: "-webkit-center" }} className={CssClass.tdBtnActionWrapperTwo}>
                      <span title="Modify">
                        <Comp.Button
                          id="btnEdit"
                          type="general"
                          onClick={(e) => showUpdateEntitlementModal(e, rowData)}
                          style={{ width: "55px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
                        >
                          <FontAwesomeIcon icon={faPenToSquare} />
                        </Comp.Button>
                      </span>
                    </div>
                  )}
                />
                <Column
                  header="#"
                  body={(rowData, options) => options.rowIndex + 1 + currentPage * rowsPerPage}
                  style={{ width: '1rem', textAlign: 'center' }}
                />
                <Column header="Category" field="CATEGORY_DESC" style={{ width: '12rem' }}></Column>
                <Column header="Type" field="CATEGORY_TYPE_NAME" style={{ width: '12rem' }}></Column>
                <Column 
                  header="Entitlement" 
                  field="ENTITLEMENT" 
                  style={{ width: '12rem' }}
                  body={(data) => 
                    (data.CATEGORY_TYPE_MST_ID === '46E44004-B5D3-4702-A188-3C09A6F663A9') 
                      ? `RM ${data.ENTITLEMENT}` 
                      : `${data.ENTITLEMENT} days`
                  }
                />
              </DataTable>
            </div>
              <input
                id="EMAIL_HOLIDAY"
                name="Email Holiday List"
                type="checkbox"
                onChange={emailHolidayHandler}
              />
              &nbsp;<label>Email gazetted holiday list</label>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="onright-container">
            <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={handleBack}
            >
              <FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
            </Comp.Button>
              
            <Comp.Button id="btnSave" onClick={handleConfirm}>
              <FontAwesomeIcon icon={faCheck} />&nbsp; Save
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={showUpdateEntitlement} onHide={hideUpdateEntitlementModal} centered size="sg">
        <Modal.Header>
          <div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
            <Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Edit Leave Entitlement</Modal.Title>
          </div>
        </Modal.Header>
    
        <Modal.Body>
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="CATEGORY_DESC"
                  label="Category"
                  name="Category"
                  type="text"
                  className="form-control"
                  value={editEntitlementData?.CATEGORY_DESC}
                  readOnly
                />
              </div>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="CATEGORY_TYPE_NAME"
                  label="Type"
                  name="Type"
                  type="text"
                  className="form-control"
                  value={editEntitlementData?.CATEGORY_TYPE_NAME}
                  readOnly
                />
              </div>
            </div>

            <Comp.Input
              id="ENTITLEMENT"
              label="Entitlement*"
              name="Entitlement"
              type="text"
              className="form-control"
              errorMessage={inputError.ENTITLEMENT}
              value={editEntitlementData?.ENTITLEMENT}
              onChange={inputEntitlementRequiredHandler}
            />
          </div>
        </Modal.Body>
    
        <Modal.Footer>
          <div className="onright-container">
            <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={handleEntitlementBack}
            >
              <FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
            </Comp.Button>
                
            <Comp.Button id="btnSave" onClick={handleEntitlementConfirm}>
              <FontAwesomeIcon icon={faCheck} />&nbsp; Save
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal */}
      <BackModal
        show={showBackModal}
        onHide={handleConfirmBackCancel}
        onConfirm={handleConfirmBack}
        prop="Confirm Navigation"
      >
        Are you sure you want to go back? Your changes may be lost.
      </BackModal>

      <ConfirmModal
          show={showConfirmModal}
          onHide={handleConfirmModalClose}
          onConfirm={handleConfirmModal}
          prop="Confirm to save"
      >
        Are you sure you want to create new employee?
      </ConfirmModal>
      
      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default InsertEmployee;
